import PropTypes from 'prop-types';
import { addressPropTypes, fieldPropTypes, personNamePropTypes } from '../../../propTypes';

export const roomAllocationPropTypes = PropTypes.shape({
  index: PropTypes.number,
  key: PropTypes.string,
});

export const roomsPropTypes = PropTypes.shape({
  capacity: PropTypes.number,
  code: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      isFull: PropTypes.bool,
      occupancy: PropTypes.number.isRequired,
    })
  ),
  key: PropTypes.string,
  roomName: PropTypes.string,
});

export const leadBookerPropTypes = PropTypes.shape({
  address: addressPropTypes,
  dateOfBirth: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  emailAddress: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  fullName: personNamePropTypes,
  mailingAddress: addressPropTypes,
  mailingFullName: personNamePropTypes,
  mobile: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  mobileCountryDialCode: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  mobileCountryDialCodeName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  phone: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  phoneCountryDialCode: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  phoneCountryDialCodeName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
});

export const partyMemberPropTypes = PropTypes.shape({
  chestSizeKey: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  dateOfBirth: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  fullName: personNamePropTypes,
  insuranceCover: PropTypes.bool,
  otherRequirements: PropTypes.oneOfType([PropTypes.string, fieldPropTypes]),
  accommodationSubItemAllocations: PropTypes.arrayOf(roomAllocationPropTypes),
});
